import React, {
    useState,
    useEffect,
    useMemo,
    useCallback,
    useRef,
} from "react";
import Pagination from "react-js-pagination";
import moment from 'moment';
import Header from "./../../Header";
import "../../assets/css/alie.css";
import Train from "./train";
import ReactModal from "react-modal";

import CheckPicker from "rsuite/CheckPicker";
import "rsuite/CheckPicker/styles/index.css";

import { FiMoreVertical } from "react-icons/fi";
import { FaSyncAlt, FaTrashAlt, FaBan, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const DocumentTraining = () => {
    const [documents, setDocuments] = useState([]);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const debounceTimeout = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 20;
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [showAiChatModal, setShowAiChatModal] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedAgents, setSelectedAgents] = useState([]);
    const [selectedDocTypes, setSelectedDocTypes] = useState([]);

    const [agents, setAgents] = useState([]);

    const [filter, setFilter] = useState([]);

    const statusOptions = [
        { label: "Draft", value: 0 },
        { label: "Trained", value: 1 },
        { label: "Pending", value: 2 },
        { label: "Failed", value: 3 },
        { label: "Blocked", value: 5 },
    ];

    const storedPermission = localStorage.getItem("user_permission");

    const parsedPermission = storedPermission ? storedPermission.split(",") : null;

    // if (!parsedPermission) {
    //     window.location.href = "/404"; // Redirect to login if no permissions found
    //     return;
    // } else if (!parsedPermission.includes("16")) {
    //     //Check permission does not incluses 
    //     window.location.href = "/404"; // Redirect to login if no permissions found
    //     return;
    // }


    const fetchAgents = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_CRM}/ai/agents`);
            const result = await response.json();
            setAgents(result.data || []);
        } catch (err) {
            console.error("Failed to fetch agents", err);
        }
    };

    const fetchDocuments = async () => {
        setLoading(true);
        try {

            const buildFilters = () => {

                const filters = {};

                if (filter.length > 0) {
                    filters.is_processed = filter;   // array
                }
                if (selectedAgents.length > 0) {
                    filters.agent_id = selectedAgents; // array
                }
                if (selectedDocTypes.length > 0) {
                    filters.document_type = selectedDocTypes; // array
                }

                return Object.keys(filters).length > 0 ? filters : null;
            };

            const payload = {
                page: currentPage,
                per_page: perPage,
                ...(search && { search }),
                ...(buildFilters() && { filters: buildFilters() }),
            };

            const response = await fetch(`${process.env.REACT_APP_CRM}/ai/docs`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            setDocuments(result.data || []);
            setTotal(result.total || 0);
            // if (onTotalChange) {
            //     onTotalChange(result.total || 0);
            // }
        } catch (err) {
            console.error("Failed to fetch documents", err);
        } finally {
            setLoading(false);
        }
    };

    const handleRefreshDocuments = () => {
        setCurrentPage(1); // 🔥 Reset to page 1 first
        // Wait for setCurrentPage to complete before fetching documents
        setTimeout(() => {
            fetchDocuments(); // 🔥 Then fetch documents with updated page
        }, 0);
    };

    useEffect(() => {
        fetchAgents();  // load agents at mount
    }, []);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setCurrentPage(1); // reset to page 1 on new search
        }, 400);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);


    useEffect(() => {
        fetchDocuments();
    }, [filter, selectedAgents, selectedDocTypes, currentPage, debouncedSearch]);


    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const handleDelete = (id) => {
        // Call the API to delete the document 
        fetch(`${process.env.REACT_APP_CRM}/ai/delete/docs`, {
            method: "POST",
            body: JSON.stringify({ document_id: id }),
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.ok) {
                    // Document deleted successfully, refresh the documents list
                    fetchDocuments();
                } else {
                    console.error("Failed to delete document", response.statusText);
                }
            })
    };

    const handleBlock = (id) => {
        // Call the API to delete the document 
        fetch(`${process.env.REACT_APP_CRM}/ai/block/docs`, {
            method: "POST",
            body: JSON.stringify({ document_id: id }),
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.ok) {
                    // Document deleted successfully, refresh the documents list
                    fetchDocuments();
                } else {
                    console.error("Failed to delete document", response.statusText);
                }
            })
    };

    return (
        <div>
            <Header brecum_name="AI" brecum_page="Train" />
            <div className="right_col">
                <div className="ticket_list">
                    <div class="customer-wrap">
                        <div class="page-top">
                            <div className="containerfull">

                                <div className="row align-items-center">

                                    <div class="col-md-12">
                                        <div class="d-flex justify-content-between align-items-center">

                                            <div class="d-flex align-items-center">
                                                <h2>Documents</h2>
                                                <span class="badge-blue">{total}</span>
                                            </div>
                                            <div>
                                                {
                                                    parsedPermission && parsedPermission.includes("16") && (
                                                        <button
                                                            className="btn btn-sky"
                                                            data-toggle="modal"
                                                            data-target="#documentModal"
                                                        >
                                                            <i className="fas fa-plus mr-5 font-500"></i>

                                                            Add Documents
                                                        </button>
                                                    ) 
                                                }

                                                {/* <Train/> */}
                                                <Train

                                                    initialUrl={selectedDocument && selectedDocument.document_url ? selectedDocument.document_url : ""}
                                                    refreshDocuments={handleRefreshDocuments}
                                                    agents={agents}
                                                    documentAgent={
                                                        selectedDocument && Array.isArray(selectedDocument.agents)
                                                            ? selectedDocument.agents.map(a => a.agent_id)
                                                            : []
                                                    }
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-10">
                                    <div class="col-md-8">
                                        <div class="d-flex">
                                            {/* 🔥 Status CheckPicker */}
                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={statusOptions}
                                                    value={filter}
                                                    onChange={(values) => {
                                                        setFilter(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Status"
                                                    style={{ width: 200 }}
                                                    cleanable
                                                    searchable={false}
                                                />
                                            </div>

                                            {/* 🔥 Agent CheckPicker */}
                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={agents.map((agent) => ({
                                                        label: agent.agent_name,
                                                        value: agent.agent_id,
                                                    }))}
                                                    value={selectedAgents}
                                                    onChange={(values) => {
                                                        setSelectedAgents(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Agent"
                                                    style={{ width: 224 }}
                                                    searchable={false}
                                                />
                                            </div>

                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={[
                                                        { label: "URL", value: "url" },
                                                        { label: "Google Doc", value: "google_doc" },
                                                    ]}
                                                    value={selectedDocTypes}
                                                    onChange={(values) => {
                                                        setSelectedDocTypes(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Document Type"
                                                    style={{ width: 224 }}
                                                    searchable={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="searchTicket emp_dept">
                                            <input
                                                type="text"
                                                className="form-control input-f"
                                                placeholder="Search by title"
                                                autocomplete="off"
                                                value={search}
                                                onChange={handleSearchChange}
                                            />
                                            <button type="submit">
                                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M15.75 16.25L12.4875 12.9875" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </button>
                                        </div>

                                    </div>

                                </div>


                                {loading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <div className="employee-list table-wrap mt-10">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Document Title</th>
                                                    <th>Status</th>
                                                    <th>Agent</th>
                                                    <th>Last Updated</th>
                                                    {
                                                        parsedPermission && parsedPermission.includes("16") && (
                                                            <th>Action</th>
                                                        )
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.map((doc) => (
                                                    <tr key={doc.id}>
                                                        <td><a href={doc.document_url} target="_blank" rel="noopener noreferrer">{doc.id}</a></td>
                                                        <td>
                                                            <a href={doc.document_url} target="_blank" rel="noopener noreferrer">
                                                                {doc.document_title.length > 50
                                                                    ? doc.document_title.slice(0, 50) + "..."
                                                                    : doc.document_title}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {doc.is_processed === 1 ? (
                                                                <span className="badge badge-success bg-success">Trained</span>
                                                            ) : doc.is_processed === 2 ? (
                                                                <span className="badge badge-info bg-info">Pending</span>
                                                            ) : doc.is_processed === 3 ? (
                                                                <span className="badge badge-danger bg-danger">Failed</span>
                                                            ) : doc.is_processed === 5 ? (
                                                                <span className="badge badge-danger bg-secondary">Blocked</span>
                                                            ) : (
                                                                <span className="badge badge-warning bg-warning">Draft</span>

                                                            )}
                                                        </td>

                                                        <td>
                                                            {doc.agents && doc.agents.length > 0 ? (
                                                                doc.agents.map((a, idx) => {
                                                                    const match = agents.find(agent => agent.agent_id === a.agent_id);
                                                                    const name = match ? match.agent_name : a.agent_id;

                                                                    return (
                                                                        <span
                                                                            key={a.agent_id}
                                                                            className={a.status === 1 ? "text-black" : "text-danger"}
                                                                            style={{ marginRight: "10px" }}
                                                                        >
                                                                            {name}
                                                                            {idx < doc.agents.length - 1 && ","}
                                                                        </span>
                                                                    );
                                                                })
                                                            ) : (
                                                                "—"
                                                            )}
                                                        </td>

                                                        <td>
                                                            {moment(doc.created_at).format('YYYY-MM-DD hh:mm A')}
                                                        </td>

                                                        {
                                                            parsedPermission && parsedPermission.includes("16") && (
                                                                <td>
                                                                    <div className="dropdown">
                                                                        {/* Trigger button (3 dots) */}
                                                                        <button
                                                                            className="btn btn-default dropdown-toggle"
                                                                            type="button"
                                                                            id={`dropdownMenu-${doc.id}`}
                                                                            data-toggle="dropdown"
                                                                            aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            style={{
                                                                                color: "#000",
                                                                                paddingTop: "10px",
                                                                                fontSize: "24px",
                                                                                background: "transparent",
                                                                                border: "none",
                                                                            }}
                                                                        >
                                                                            <FiMoreVertical />
                                                                        </button>

                                                                        {/* Dropdown menu */}
                                                                        <ul
                                                                            className="dropdown-menu dropdown-menu-right"
                                                                            aria-labelledby={`dropdownMenu-${doc.id}`}
                                                                        >
                                                                            <li>
                                                                                <a
                                                                                    href="#"
                                                                                    data-toggle="modal"
                                                                                    data-target="#documentModal"
                                                                                    onClick={() => {
                                                                                        setSelectedDocument(doc); // keep your original modal trigger
                                                                                    }}
                                                                                >
                                                                                    <FaSyncAlt className="text-primary" /> Retrain
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setSelectedDocId(doc.id);
                                                                                        setShowAiChatModal(true);
                                                                                    }}
                                                                                >
                                                                                    <FaTrashAlt className="text-danger" /> Delete
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        handleBlock(doc.id);
                                                                                    }}
                                                                                >
                                                                                    <FaBan className="text-warning" /> Block
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            )
                                                        }


                                                    </tr>
                                                ))}
                                                {documents.length === 0 && (
                                                    <tr><td colSpan="5" className="text-center">No documents found</td></tr>
                                                )}
                                            </tbody>
                                        </table>

                                        {total > perPage && (
                                            <div className="d-flex mu-pagination justify-content-between align-items-center" aria-label="Page navigation example">
                                                <div className="mu-pagination__info">
                                                    <p className="mu-pagination__info-text">Showing {Math.min((currentPage - 1) * perPage + 1, total)} to {Math.min(currentPage * perPage, total)} of {total} entries</p>
                                                </div>
                                                <div className="mu-pagination">
                                                    <Pagination
                                                        activePage={currentPage}
                                                        itemsCountPerPage={perPage}
                                                        totalItemsCount={total}
                                                        pageRangeDisplayed={5}
                                                        itemClass="page-item"
                                                        linkClass="page-link"
                                                        onChange={setCurrentPage}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>

                            <ReactModal
                                isOpen={showAiChatModal}
                                onRequestClose={() => setShowAiChatModal(false)}
                                className="styled-modal"
                                overlayClassName="styled-modal-overlay"
                                ariaHideApp={false}
                            >
                                <div className="p-4">
                                    <h5 className="fw-semibold mb-3">Delete Document</h5>
                                    <p className="text-muted mb-4">
                                        Are you sure you want to delete the document with ID {selectedDocId}? This action cannot be undone.
                                    </p>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={() => setShowAiChatModal(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-danger"
                                            onClick={() => {
                                                handleDelete(selectedDocId); // use selectedDocId here
                                                setShowAiChatModal(false);   // close modal after delete
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </ReactModal>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentTraining;



// WEBPACK FOOTER //
// ./src/components/ai/DocumentTraining.js